export default "__VITE_ASSET__TBB1GbwE__"